import comp from "./CardSkeletonLoader";
export default comp;
